import { DistributionChannel } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { ChannelTone, MessageDestination, TimelineFilterValues } from './StayTimeline.types'

export const zendeskTicketUrl = (ticketId: string) =>
  `https://avantstay.zendesk.com/agent/tickets/${ticketId}`

export const DEFAULT_TIMELINE_FILTERS: TimelineFilterValues = {
  sends: 'mainGuest',
  notes: true,
  channels: [],
}

export const CHAT_TRANSCRIPT_MEDIUM = 'chat_transcript'
export const CHAT_TRANSCRIPT_TIMEZONE = 'America/Los_Angeles'

export const SPOKEPHONE_LABEL = 'Spokephone'

export const TIMELINE_HIDDEN_GRACE_MS = 15_000

export const OTA_REPLY_CHANNELS: DistributionChannel[] = [
  DistributionChannel.vrbo,
  DistributionChannel.airbnb,
  DistributionChannel.rentalsUnited,
]

export const CHANNEL_FILTER_OPTIONS: Array<{ value: ChannelTone; label: string }> = [
  { value: 'push', label: 'App push' },
  { value: 'call', label: 'Call' },
  { value: 'chat', label: 'Chat' },
  { value: 'email', label: 'Email' },
  { value: 'ota', label: 'OTA messages' },
  { value: 'sms', label: 'SMS' },
  { value: 'other', label: 'Other' },
]

export const DESTINATION_CHANNEL_TONES: Record<MessageDestination, ChannelTone> = {
  spokephone: 'sms',
  ota: 'ota',
}
